import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const ReviewQuestionnairePage = Loadable(
  lazy(() =>
    import("./ReviewQuestionnaire").then(({ ReviewQuestionnaire }) => ({
      default: ReviewQuestionnaire,
    })),
  ),
);

const ReviewQRPage = Loadable(lazy(() => import("./ReviewQR")));

const ManageReviewQuestionnairePage = Loadable(
  lazy(() => import("./ManageReviewQuestionnaire")),
);

export const reviewQuestionnaireRoutes = [
  {
    path: `${REACT_APP_NAV_ROUTES.review.ManageReviewQuestionnaire}/:questionnaireUuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVIEW]}>
        <ManageReviewQuestionnairePage />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.review.ManageReviewQuestionnaire,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVIEW]}>
        <ManageReviewQuestionnairePage />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.review.ReviewQuestionnaire,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVIEW]}>
        <ReviewQuestionnairePage />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.review.ReviewQR,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVIEW_QUESTIONNAIRE]}>
        <ReviewQRPage />
      </AuthorizedRoute>
    ),
  },
];
